import type { GoalFormModel } from "web_myplann/Goals/Forms/useGoalForm";
import { isRentBasedCategory } from "web_myplann/Goals/Helpers/goalCategory";
import { monthlyContribution } from "web_myplann/Goals/Helpers/monthlyContribution";
import { RentDrawdownMode } from "web_myplann/Goals/Types/RentDrawdownMode";
import {
	type CreateGoalRequestDTO,
	CurrencyEnum,
	GoalCategoryTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { formatApiDate } from "web_myplann/Shared/Utils/apiDate";

export const mapGoalFormToRequest = (
	data: GoalFormModel,
): Omit<CreateGoalRequestDTO, "investmentPlanCategoryType"> => {
	const ownFunds = data.ownFunds ?? 0;
	const loanAmount = data.loanAmount ?? 0;
	const savingsTarget = Math.max(0, data.totalValue - ownFunds - loanAmount);
	const periodicPayment = monthlyContribution(savingsTarget, data.dueDate);
	const isPension = data.category === GoalCategoryTypeEnum.Pension;
	const isRentBased = isRentBasedCategory(data.category);
	const isToZero = isRentBased && data.drawdownMode === RentDrawdownMode.ToZero;

	return {
		name: data.name,
		investmentHorizonEndDate: formatApiDate(data.dueDate),
		currencyCode: CurrencyEnum.CZK,
		oneTimePayment: data.totalValue,
		periodicPayment: periodicPayment > 0 ? periodicPayment : null,
		loanAmount,
		ownFunds,
		monthlyRent: isRentBased ? (data.monthlyRent ?? null) : null,
		rentYears: isToZero ? (data.rentYears ?? null) : null,
		statePension: isPension ? (data.statePension ?? 0) : null,
	};
};
